var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesHideShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-hide-show") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "features-hide-show"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007FAD",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375,3.59130435 C10.875,3.34782609 10.3125,3.22608696 9.75,3.22608696 C7.6875,3.22608696 6,4.86956522 6,6.87826087 C6,7.42608696 6.125,7.97391304 6.375,8.46086957 L11.375,3.59130435 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125,10.226087 C8.625,10.4695652 9.1875,10.5913043 9.75,10.5913043 C11.8125,10.5913043 13.5,8.94782609 13.5,6.93913043 C13.5,6.39130435 13.375,5.84347826 13.125,5.35652174 L8.125,10.226087 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875,9.92173913 C2.9375,8.52173913 1.5625,6.93913043 1.5625,6.93913043 C1.5625,6.93913043 5.625,2.06956522 9.6875,2.06956522 C10.5625,2.06956522 11.4375,2.31304348 12.3125,2.67826087 L13.25,1.76521739 C12.125,1.2173913 10.9375,0.852173913 9.6875,0.852173913 C5.1875,0.852173913 0.8125,5.90434783 0.625,6.14782609 L2.30926389e-14,6.93913043 L0.625,7.73043478 C0.75,7.85217391 2.0625,9.43478261 4,10.8347826 L4.875,9.92173913 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8125,6.14782609 C18.75,6.02608696 17.375,4.44347826 15.5,3.04347826 L14.625,3.89565217 C16.5625,5.29565217 17.9375,6.87826087 17.9375,6.87826087 C17.9375,6.87826087 13.875,11.7478261 9.8125,11.7478261 C8.9375,11.7478261 8.0625,11.5043478 7.1875,11.1391304 L6.25,12.0521739 C7.375,12.6 8.5625,12.9652174 9.8125,12.9652174 C14.375,12.9652174 18.6875,7.85217391 18.875,7.66956522 L19.5,6.87826087 L18.8125,6.14782609 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(9.745091, 6.944752) rotate(-45.000000) translate(-9.745091, -6.944752) ",
    points: "0.149122869 6.5095657 19.3329063 6.76309587 19.3410584 7.37993778 0.157274965 7.12640761"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesHideShow);
export default __webpack_public_path__ + "static/media/features-hide-show.e8ec49b9c18fcb2205af973fa8af05ed.svg";
export { ForwardRef as ReactComponent };